class HttpClient {
    static async execute(url, method = 'GET', headers = {}, data = {}) {
        return this.doExecute(url, this.createRequestObject(method, headers, data));
    }

    static async doExecute(url, request) {
        try {
            // eslint-disable-next-line no-undef
            return await fetch(url, request);
        } catch (e) {
            console.error(e);
            throw e;
        }
    }

    static createRequestObject(method, headers, data) {
        return method === 'GET'
            ? {
                method,
                headers,
            } : {
                method,
                body: data,
                headers,
            };
    }
}

export default HttpClient;
